// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__URqF7","footer":"ReportModalFilter_footer__2kBxw"};